exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".QuoteBox__container{background:#f4f4f4;padding:1.25rem;text-align:center;max-width:19.88rem}.QuoteBox__text{margin-top:.313rem;margin-bottom:1.25rem;font-size:1rem;line-height:1.375rem;text-align:center;letter-spacing:normal}.QuoteBox__author{font-style:normal}.QuoteBox__author::before{display:none}", ""]);

// exports
